module.exports = __webpack_public_path__ + "static/media/icon-alert.5008a1a3.svg";